import { render, staticRenderFns } from "./water-list.vue?vue&type=template&id=f8c80bd2&scoped=true&"
import script from "./water-list.vue?vue&type=script&lang=js&"
export * from "./water-list.vue?vue&type=script&lang=js&"
import style0 from "./water-list.vue?vue&type=style&index=0&id=f8c80bd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c80bd2",
  null
  
)

export default component.exports